import React from "react";
import "./Modal.scss";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { CustomButton } from "components/form";
// Custom Modal
export const CustomModal = ({
  size,
  show,
  action,
  children,
  className,
  handleClose,
}) => {
  return (
    <Modal
      centered
      show={show}
      size={size}
      backdrop="static"
      onHide={handleClose}
      className={`custom_modal ${className}`}
    >
      <Modal.Body>
        <div className="modal_content">
          <button className="cancel_button" onClick={handleClose}>
            <FaTimes />
          </button>
          {children}
        </div>
      </Modal.Body>
    </Modal>
  );
};

// Delete Modal
export const PopupModal = ({
  show,
  handleClose,
  title,
  content,
  action,
  onShow,
  buttonLoader,
  children,
}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
        className="custom_modal delete_modal"
        onShow={onShow}
      >
        <Modal.Body>
          <h3 className="title">{title}</h3>
          <p className="content">{content}</p>
          {children ? (
            children
          ) : (
            <div className="button_wrap">
              <button
                type="button"
                className="button light"
                onClick={handleClose}
              >
                No
              </button>
              <button
                ref={buttonLoader}
                type="button"
                className="button"
                onClick={action}
              >
                Yes
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
//
